import type { FC } from 'react';

import { NewTopMdScores } from '@/domains/productDiscovery/ArticleReviews/components/NewTopMdScores/NewTopMdScores';
import { HeaderTags } from '@/domains/productDiscovery/ProductPage/b2c/modules/Header/HeaderTags/HeaderTags';
import { SeeProductDetail } from '@/domains/productDiscovery/ProductPage/b2c/modules/Header/SeeProductDetail/SeeProductDetail';
import { Rating as RedesignedRating } from '@/domains/productDiscovery/ProductPage/common/components/Rating/Rating';
import { LazyCarbonScoreOverview } from '@/domains/sustainability/carbonScore/components/CarbonScoreOverview/LazyCarbonScoreOverview';
import { SecondHandProductConditionTag } from '@/domains/sustainability/secondHand/components/SecondHandProductConditionTag/SecondHandProductConditionTag';

import styles from './Header.module.scss';

export const Header: FC = () => (
  <div className={styles.header}>
    <div className={styles.headerItem}>
      <RedesignedRating />
    </div>
    <div className={styles.headerItem}>
      <NewTopMdScores />
    </div>
    <div className={styles.headerItem}>
      <HeaderTags />
    </div>
    <div className={styles.headerItem}>
      <SecondHandProductConditionTag />
    </div>
    <div className={styles.headerItem}>
      <SeeProductDetail />
    </div>
    <div className={styles.headerItem}>
      <LazyCarbonScoreOverview />
    </div>
  </div>
);
